import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { translate } from 'react-i18next';
import {
	withRouter
} from 'react-router-dom'

import DataService from 'lib/DataService';

import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';
import { BigBlueButton } from 'lib/styles';
import PageSelect from './PageSelect';
import Template from '../Template';

import {
	Container,
	RemoveButton,
	RemoveContainer,
	Handle,
	Dimmer,
	PagesContainer,
	Pages,
	Page,
	PageLink,
	DragHandle,
	PageNumber,
	ButtonContainer,
} from './styles';

const Api = new DataService();
// scale: 0.2449
class PageList extends React.PureComponent {
	state = {
	  loading: false,
	  pageSelectOpen: false,
	  canSort: true,
	  removePages: [],
	}

	removePagesHandler = () => {
	  const { t, lng, brochureId, pages } = this.props;

	  if (!this.state.loading && window.confirm(t('brochure/Page list/Remove selected page/Confirm', { count: this.state.removePages.length }))) {
	    const pageIds = this.state.removePages.map(pageIndex => pages[pageIndex].id);
	    const remainingPages = pages.filter(page => !pageIds.includes(page.id));
	    const redirectPage = remainingPages.length ? remainingPages[0].id + '/' : '';

	    this.setState({ loading: true });

	    Api.deletePages({ brochureId, pageIds })
	      .then(res => {
	        this.props.history.push(`/${lng}/t/brochure/${brochureId}/${redirectPage}`);
	        this.props.updateContentHandler(res.result.content);
	        this.setState({
	          loading: false,
	          removePages: [],
	        });
	      });
	  }
	}

	removePageToggleHandler = (event, index) => {
	  event.preventDefault();
	  event.stopPropagation();

	  const removePages = [...this.state.removePages];

	  if (removePages.indexOf(index) === -1) {
	    removePages.push(index);
	  } else {
	    removePages.splice(removePages.indexOf(index), 1);
	  }

	  this.setState({ removePages });
	}

	pageSelectToggleHandler = pageSelectOpen => {
	  this.setState({ pageSelectOpen });
	}

	pageListToggleHandler = () => {
	  this.setState({ pageSelectOpen: false });
	  this.props.togglePageListHandler()
	}

	// Page sort drag end
	onDragEnd = ({ destination, draggableId }) => {
	  const {
	    brochureId,
	    pages,
	  } = this.props;

	  if (!destination) {
	    return;
	  }

	  console.log(`Page with id ${draggableId} moved to index ${destination.index}`);

	  if (destination.droppableId !== 'pages') {
	    return;
	  }

	  const pageFrom = pages.findIndex(page => page.id === draggableId);
	  const pageTo = destination.index;

	  if (pageFrom === -1) {
	    return;
	  }

	  this.setState({ canSort: false });

	  this.props.movePageHandler({ pageFrom, pageTo });

	  Api.movePage({ brochureId, pageFrom, pageTo })
	    .then(res => {
	      console.log(res.code);
	      this.setState({ canSort: true });
	    });
	}

	render() {
	  const {
	    t,
	    lng: language,
	    open,
	    pages,
	    brochureId,
	    activePage,
	    editable,
	    brochureType
	  } = this.props;
	  const handleTitle = open ? 'Sulje sivulistaus' : 'Avaa sivulistaus';

	  return (
	    <DragDropContext onDragEnd={this.onDragEnd}>
	      <Container open={open} brochureEditable={editable}>
	        <Pages>
	          <Droppable droppableId="pages" direction="vertical">
	            {provided => (
	              <PagesContainer
	                innerRef={provided.innerRef}
	                brochureEditable={editable}
	                hasRemoveablePages={this.state.removePages.length > 0}
	                {...provided.droppableProps}
	              >
	                {pages.map((page, pageIndex) => {
	                  const active = page.id === activePage;
	                  const pageNumber = pageIndex + 1;
	                  const bgColor = page.options['background-color'] || 'white';

	                  return (
	                    <Draggable key={page.id} draggableId={page.id} index={pageIndex}>
	                      {(provided, snapshot) => (
	                        <Page
	                          orientation={this.props.orientation}
	                          page={page}
	                          active={active ? 1 : 0}
	                          style={{backgroundColor: bgColor}}
	                          innerRef={provided.innerRef}
	                          {...provided.draggableProps}
	                        >
	                          <RemoveContainer
	                            active={this.state.removePages.includes(pageIndex)}
	                          >
	                            <Tooltip
	                              icon="trash"
	                              tooltip="Merkitse sivu poistettavaksi"
	                              onClickHandler={event => this.removePageToggleHandler(event, pageIndex)}
	                            />
	                          </RemoveContainer>
	                          <PageNumber>{ pageNumber }</PageNumber>
	                          <PageLink
	                            delete={this.state.removePages.includes(pageIndex) ? 1 : 0}
	                            to={`/${language}/t/brochure/${brochureId}/${page.id}/`}
	                          >
	                            {
	                              this.props.open &&
																<Template
																  editable={false}
																  showReadOnlyNotice={false}
																  lowres={true}
																  user={{ can: { update: { master: () => false }}}}
																  building={this.props.building}
																  pictograms={this.props.pictograms}
																  config={this.props.config}
																  brochureId={this.props.brochureId}
																  pageId={page.id}
																  activeSlot={null}
																  data={page}
																  unsavedChanges={this.props.unsavedChanges}
																  itemActiveIndex={-1}
																  controlsOpen={false}
																  editorState={this.props.editorState}
																  resetChangesHandler={() => {}}
																  activeSlotHandler={() => {}}
																  toggleControlsHandler={() => {}}
																  changesHandler={() => {}}
																  updateEditorState={() => {}}
																/>
	                            }
	                            <DragHandle
	                              canSort={editable && this.state.canSort}
	                              isDragging={snapshot.isDragging}
	                              {...provided.dragHandleProps}
	                            >
	                              <Icon className="icon" icon="cheveron-up" />
	                              <Icon className="icon" icon="cheveron-down" />
	                            </DragHandle>
	                          </PageLink>
	                        </Page>
	                      )}
	                    </Draggable>
	                  )}
	                )}
	                {provided.placeholder}
	              </PagesContainer>
	            )}
	          </Droppable>
	          <Handle
	            title={handleTitle}
	            onClick={this.pageListToggleHandler}
	          />
	        </Pages>
	        {
	          editable &&
						<ButtonContainer>
						  {
						    this.state.removePages.length > 0 &&
								<RemoveButton onClick={this.removePagesHandler}>
								  {t('brochure/Page list/Remove selected page', { count: this.state.removePages.length })}
								</RemoveButton>
						  }
						  <BigBlueButton onClick={() => {
						    this.setState({ removePages: [] });
						    this.pageSelectToggleHandler(true);
						  }}>
						    {t('brochure/Page list/Add new page')}
						  </BigBlueButton>
						</ButtonContainer>
	        }
	      </Container>
	      <Dimmer
	        title={handleTitle}
	        open={open}
	        onClick={this.pageListToggleHandler}
	      />
	      {
	        this.props.open && this.state.pageSelectOpen &&
					<PageSelect
					  brochureId={brochureId}
					  brochureType={brochureType}
					  pages={pages}
					  closeHandler={() => this.pageSelectToggleHandler(false)}
					  addPageHandler={this.props.addPageHandler}
					/>
	      }
	    </DragDropContext>
	  );
	}
}

PageList.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	history: PropTypes.object,
	building: PropTypes.object,
	pictograms: PropTypes.array,
	config: PropTypes.object,
	unsavedChanges: PropTypes.object,
	editorState: PropTypes.object,
	open: PropTypes.bool,
	pages: PropTypes.array,
	orientation: PropTypes.oneOf(['landscape', 'portrait']),
	editable: PropTypes.bool,
	brochureId: PropTypes.string,
	brochureType: PropTypes.oneOf(['normal', 'default', 'master']),
	user: PropTypes.object,
	togglePageListHandler: PropTypes.func,
	activePage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	addPageHandler: PropTypes.func,
	updateContentHandler: PropTypes.func,
	movePageHandler: PropTypes.func,
};

export default withRouter(translate('translations')(PageList));
